import SmoothScroll from '../singleton/SmoothScroll';

class Tooltip {
  private $tooltipEls: JQuery<HTMLElement>;
  private $modal: JQuery<HTMLElement>;
  private $modalClose: JQuery<HTMLElement>;
  private $modalCopy: JQuery<HTMLElement>;
  private smoothScroll: typeof SmoothScroll;

  constructor() {
    this.$tooltipEls = jQuery('.tooltip');
    this.$modal = jQuery('.tooltip-modal');
    this.$modalClose = jQuery('.tooltip-modal-close');
    this.$modalCopy = this.$modal.find('.tooltip-modal-copy');
    this.smoothScroll = SmoothScroll;

    if (!this.$tooltipEls.length) return;

    this.init();
  }

  private init() {
    this.setupClickHandlers();
    this.setupModalHandlers();
  }

  private setupClickHandlers() {
    // Handle tooltip click to open modal
    this.$tooltipEls.on('click', (e) => {
      e.preventDefault();
      const $el = jQuery(e.currentTarget);
      const copy = $el.data('tooltip-copy') || '';
      const direction = $el.data('tip-direction') || 'default';

      if (!copy) return;

      this.$modalCopy.html(copy);
      this.$modal.attr('data-tip-direction', direction);
      this.openModal();
    });
  }

  private setupModalHandlers() {
    // Handle modal close button
    this.$modalClose.on('click', () => {
      this.closeModal();
    });

    // Close modal when clicking outside
    this.$modal.on('click', (e) => {
      if (jQuery(e.target).hasClass('tooltip-modal')) {
        this.closeModal();
      }
    });

    // Close modal on Escape key
    jQuery(document).on('keydown', (e) => {
      if (e.key === 'Escape' && this.$modal.attr('aria-hidden') === 'false') {
        this.closeModal();
      }
    });
  }

  private openModal() {
    this.smoothScroll.disableScrolling();
    this.$modal.attr('aria-hidden', 'false');
  }

  private closeModal() {
    this.$modal.attr('aria-hidden', 'true');
    this.smoothScroll.enableScrolling();
  }
}

export default Tooltip;
